import React, { useEffect, useState } from 'react';
import {
  Button,
  Card,
  Col,
  Divider,
  Image,
  InputNumber,
  message,
  notification,
  Popconfirm,
  Result,
  Row,
  Spin,
  Tooltip,
  Transfer,
  Upload
} from 'antd';
import { useFetchPageData, usePageData } from '../../../../hooks/usePage';
import { IPageData } from '../../../../interfaces/page';
import { IEleccion, Usuario } from '../../../../interfaces/elecciones/eleccion';
import EleccionVigente from './component/eleccionvigente';
import './postulantes.css';
import { IResponse } from '../../../../interfaces/response';
import eleccionesProvider from '../../../../services/eleccionesProvider';
import { navigateHome } from '../../../../utils/naviagate-home';
import { CloseOutlined, MehOutlined, SmileOutlined, UploadOutlined } from '@ant-design/icons';
import administracionProvider from '../../../../services/administracionProvider';
import _ from 'lodash';
import { useAsync } from 'react-async';

const pageData: IPageData = {
  fulFilled: false,
  breadcrumbs: [
    {
      title: 'Comité SST',
      route: 'default-dashboard'
    },
    {
      title: 'Postulantes'
    }
  ]
};

const PostulantesAdmin = () => {
  usePageData(pageData);
  const [data]: any = useFetchPageData<IEleccion>('/elecciones/ObtenerEleccionVIgente', null);
  const [guardando, setguardando] = useState(false);
  const [postulantes, setpostulantes] = useState<Usuario[]>();
  const [subiendo, setsubiendo] = useState(false);

  useEffect(() => {
    if (data != null) {
      const filter = data.postulantes.map((x) => x.id);
      setTargetkey(filter);
      setpostulantes(data.postulantes);
    }
  }, [data]);

  const [targetKey, setTargetkey] = useState([]);
  const [selectedKeys, setselectedKeys] = useState([]);
  const handleChange = (nextTargetKeys) => {
    setTargetkey(nextTargetKeys);
  };
  const handleSelectChange = (sourceSelectedKeys, targetSelectedKeys) => {
    setselectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
  };
  const handleScroll = () => {};
  const guardarPostulantes = async () => {
    setguardando(true);
    if (targetKey.length > data.eleccion.maxPostulantes) {
      message.error('No se permiten añadir mas candidatos a la presente elección');
      setguardando(false);
      return;
    }
    const usuarios = _(data.usuariosDisponibles).keyBy('id').at(targetKey).value();
    const res: any = await eleccionesProvider.guardarPostulantes(usuarios);
    //TODO VALIDAR
    if (res.succeeded) {
      message.success(res.message);
      navigateHome();
    } else {
      message.warning(res.message);
    }
    setguardando(false);
  };
  const quitarAdjunto = (file, id) => {
    postulantes.map((x) => {
      if (x.id === id) x.imagen = undefined;
    });
    setpostulantes(postulantes);
  };
  const beforeAdjunto = (file, files, id) => {
    postulantes.map((x) => {
      if (x.id === id) x.imagen = files;
    });
    setpostulantes(postulantes);
    return false;
  };
  const subirImagen = async (id) => {
    setsubiendo(true);
    const postulante = _.find(postulantes, { id: id });
    if (postulante && postulante.imagen) {
      const res: any = await eleccionesProvider.guardarImagenPostulante(
        {
          id: postulante.id,
          codigo: '1000'
        },
        postulante.imagen
      );
      //TODO VALIDAR
      if (res.succeeded) {
        message.success(res.message);
        window.location.reload();
      } else {
        message.warning(res.message);
      }
    }
    setsubiendo(false);
  };
  const eliminarImagen = async (e) => {
    const res: any = await administracionProvider.eliminarImagenPerfil(e);
    if (res.succeeded) {
      notification.open({
        message: 'GESSOMA',
        description: res.message,
        icon: <SmileOutlined style={{ color: '#108ee9' }} />
      });
      navigateHome();
    } else {
      notification.open({
        message: 'GESSOMA',
        description: res.message,
        icon: <MehOutlined />
      });
    }
  };
  const obtenerImagen = async (val) => {
    const response: any = await administracionProvider.obtenerAdjunto(val.id);

    return response;
  };
  const toBase64 = (blob) =>
    new Promise((resolve, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });

  const guardarOrden = async () => {
    const res: any = await eleccionesProvider.ConfigurarOrden(postulantes);
    //TODO VALIDAR
    if (res.succeeded) {
      console.log('se guardo correctamente.');
      message.success(res.message);
    } else {
      message.warning(res.message);
    }
  };

  const rowchange = (orden, id) => {
    postulantes.map((x) => {
      if (x.id === id) x.orden = orden;
    });
  };

  const RowItem = (props) => {
    const p = props.postulante;

    const { data, error, isPending } = useAsync({ promiseFn: obtenerImagen, id: p.adjuntoId });

    if (isPending) return <p>cargando</p>;
    return (
      <tr key={p.id}>
        <th scope='row'>
          <InputNumber
            onChange={(val) => rowchange(val, p.id)}
            min={1}
            max={postulantes.length}
            size={'small'}
            style={{ width: 50 }}
            defaultValue={p.orden}
          />
        </th>
        <td>{p.nombres + ' ' + p.apellidos}</td>
        <td>
          {data !== '' ? (
            <Image width={100} src={data} />
          ) : (
            <div>
              <Upload
                key={p.id}
                maxCount={1}
                name={'adjunto'}
                onRemove={(file) => quitarAdjunto(file, p.id)}
                beforeUpload={(file, FileList) => beforeAdjunto(file, FileList, p.id)}
              >
                <Button size={'small'} icon={<UploadOutlined />}>
                  Añadir imagen de perfil
                </Button>
              </Upload>
              <Button
                type='dashed'
                size={'small'}
                onClick={() => subirImagen(p.id)}
                loading={subiendo}
                style={{ marginTop: 16 }}
              >
                {subiendo ? 'Uploading' : 'Subir Imagen'}
              </Button>
            </div>
          )}
        </td>
        <td>
          {data !== '' ? (
            <Popconfirm
              title='Seguro de eliminar la imagen del postulante?'
              onConfirm={() => eliminarImagen(p.id)}
              onCancel={() => console.log('cencelo')}
              okText='Si'
              cancelText='No'
            >
              <Button type='primary' danger>
                Eliminar <CloseOutlined />
              </Button>
            </Popconfirm>
          ) : null}
        </td>
      </tr>
    );
  };

  return (
    <>
      {data != null ? (
        <Spin spinning={guardando}>
          <Card title={'Configuración de Postulantes'}>
            <Tooltip title='Se registrara la lista de los usuarios habilitados para postular en el presente periodo.'>
              <Button
                htmlType={'button'}
                onClick={guardarPostulantes}
                disabled={
                  targetKey.length === 0 ||
                  data.eleccion.finVotacion ||
                  data.eleccion.inicioVotacion
                }
                style={{ marginBottom: 5 }}
                type='primary'
              >
                Guardar Postulantes
              </Button>
            </Tooltip>
            <Row>
              <Col span={16}>
                <Transfer
                  dataSource={data.usuariosDisponibles}
                  showSearch={true}
                  listStyle={{ width: 300, height: 300 }}
                  titles={['Usuarios', 'Postulantes']}
                  filterOption={(search, item) => {
                    const postulante = item.nombres + ' ' + item.apellidos;
                    return postulante.toLowerCase().indexOf(search.toLowerCase()) >= 0;
                  }}
                  targetKeys={targetKey}
                  selectedKeys={selectedKeys}
                  onChange={handleChange}
                  onSelectChange={handleSelectChange}
                  onScroll={handleScroll}
                  render={(item) => `${item.nombres} ${item.apellidos}`}
                  disabled={false}
                  locale={{
                    searchPlaceholder: 'Buscar usuario...',
                    itemUnit: 'Usuario',
                    itemsUnit: 'Usuarios'
                  }}
                  oneWay
                  style={{ marginBottom: 16 }}
                />
                <Divider />
                <h5>
                  Lista de postulantes {postulantes ? postulantes.length : 0}
                  <button
                    style={{ float: 'right' }}
                    type='button'
                    onClick={guardarOrden}
                    className='btn btn-link'
                  >
                    Grabar <span className={'icofont-save'} />
                  </button>
                </h5>
                <table className='table table-bordered'>
                  <tbody>
                    {postulantes ? postulantes.map((x) => <RowItem postulante={x} />) : null}
                  </tbody>
                </table>
              </Col>
              <Col span={8}>
                {data.eleccion != null ? (
                  <EleccionVigente eleccion={data} />
                ) : (
                  <Result
                    status='info'
                    title='GESSOMA'
                    subTitle='Actualmente no existe una Elección configurada.'
                  />
                )}
              </Col>
            </Row>
          </Card>
        </Spin>
      ) : (
        <Card title={'No existe perioro vigente'}>
          <p>Añadir Postulantes a la Elección vigente:</p>
        </Card>
      )}
    </>
  );
};

export default PostulantesAdmin;
